// Persistent trust footer (L0-U13, ADR 0028 D4). A small always-visible line in
// the authenticated shell that states the financial disclaimer in brief and
// links the full legal documents. The documents themselves are the public
// top-level routes (/disclaimer, /terms, /privacy) opened in a new tab.
const LEGAL_LINKS = [
  { href: "/disclaimer", label: "Disclaimer" },
  { href: "/terms", label: "Terms" },
  { href: "/privacy", label: "Privacy" },
] as const;

export function AppFooter() {
  return (
    <footer
      data-testid="app-footer"
      className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 border-t border-outline-variant px-4 py-2 text-xs text-on-surface-variant"
    >
      <span>Not financial advice. For your own record-keeping only.</span>
      <nav aria-label="Legal" className="flex items-center gap-3">
        {LEGAL_LINKS.map((link) => (
          <a
            key={link.href}
            href={link.href}
            target="_blank"
            rel="noreferrer"
            className="underline hover:text-on-surface"
          >
            {link.label}
          </a>
        ))}
      </nav>
    </footer>
  );
}
